<template>
  <FriedModal :closable="false">
    <template #header>
      <FriedModalHeader :header="title" />
    </template>
    <FriedMessage :title="$t('cc_eas_info_message_title')">
      <FriedParagraph>{{ $t('cc_eas_info_message_description') }}</FriedParagraph>
    </FriedMessage>
    <template #footer>
      <FriedModalButtonsFooter>
        <FriedButton data-external="edit-after-sent-button" @click="$emit('close')">
          {{ $t('cc_got_it_button') }}
        </FriedButton>
      </FriedModalButtonsFooter>
    </template>
  </FriedModal>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  props: {
    sender: { type: String, required: true },
  },
  emits: ['close'],
  setup(props) {
    const { t } = useI18n();
    const title = computed(() => `${props.sender} ${t('has-modified-the-document')}`);
    return { title };
  },
});
</script>
